import { render, staticRenderFns } from "./dimensional-list.vue?vue&type=template&id=4224e9d3&scoped=true"
import script from "./dimensional-list.vue?vue&type=script&lang=js"
export * from "./dimensional-list.vue?vue&type=script&lang=js"
import style0 from "./dimensional-list.vue?vue&type=style&index=0&id=4224e9d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4224e9d3",
  null
  
)

export default component.exports